(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/stryktipset/assets/javascripts/app-container.js') >= 0) return;  svs.modules.push('/modules/stryktipset/assets/javascripts/app-container.js');
"use strict";


const _React = React,
  useMemo = _React.useMemo;
const _ReactRouterDOM = ReactRouterDOM,
  Redirect = _ReactRouterDOM.Redirect,
  Route = _ReactRouterDOM.Route,
  Switch = _ReactRouterDOM.Switch;
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const _svs$core = svs.core,
  coreData = _svs$core.data,
  detect = _svs$core.detect;
const ModalHidden = svs.components.lbUi.modal.ModalHidden;
const TipsenModuleGameUrl = svs.components.sport.tipsenShared.TipsenModuleGameUrl;
const _svs$components$tipse = svs.components.tipsen.modularBase,
  TipsenNav = _svs$components$tipse.TipsenNav,
  RoutePlayFallback = _svs$components$tipse.RoutePlayFallback,
  RouteResultFallback = _svs$components$tipse.RouteResultFallback,
  HandlePath = _svs$components$tipse.HandlePath;
const tipsenLazy = svs.components.tipsen.tipsenLazy.tipsenLazy;
const selectDisplayName = svs.components.tipsen.engine.selectors.engineSelectors.selectDisplayName;
const MyBetsRouteSmygen = svs.stryktipset.MyBetsRoute;
const LazyResult = tipsenLazy('/cl/tipsen/route-result', () => svs.components.tipsen.routeResult.RouteResult, {
  fallback: RouteResultFallback
});
const LazySpela = tipsenLazy('/cl/tipsen/route-play', () => svs.components.tipsen.routePlay.RoutePlay, {
  fallback: RoutePlayFallback
});
const LazyCoupon = tipsenLazy('/cl/tipsen/route-coupon', () => svs.components.tipsen.routeCoupon.RouteCoupon);
const LazyRouteCompetition = tipsenLazy('/cl/tipsen/route-competition', () => svs.components.tipsen.routeCompetition.RouteCompetition);
const AppContainer = () => {
  const displayName = useSelector(state => selectDisplayName(state));
  const handlePathData = useMemo(() => ({
    productName: displayName,
    cmsTitle: coreData.cmsTitle
  }), [displayName]);
  return React.createElement(React.Fragment, null, React.createElement(HandlePath, {
    data: handlePathData
  }), React.createElement(ModalHidden, null, React.createElement(TipsenNav, null), React.createElement(Switch, null, React.createElement(Route, {
    component: LazyResult,
    path: "/resultat/:date([0-9]{4}-[0-9]{2}-[0-9]{2})?"
  }), React.createElement(Route, {
    component: MyBetsRouteSmygen,
    path: "/".concat(TipsenModuleGameUrl.MY_BETS)
  }), React.createElement(Route, {
    component: LazyRouteCompetition,
    path: "/tavlingar/:competitionName"
  }), React.createElement(Route, {
    component: LazyCoupon,
    path: "/".concat(TipsenModuleGameUrl.COUPON)
  }), React.createElement(Route, {
    component: LazySpela
  }))));
};
setGlobal('svs.stryktipset.AppContainer', AppContainer);

 })(window);